import React, { Fragment } from "react"
import { MdClose } from "react-icons/md"
import { useTranslation } from "react-i18next"

import { scale } from "utils"
import PlSeparator from "./PlSeparator"
import PlSpecificationItems from "./PlSpecificationItems"
import { deliveryTypeLabels } from "constant"

const PlOrderItemsPrintTemplate = (props) => {
  const {
    forPos,
    printData,
    templateType,
    thisPrinterOrderItem,
    printerWidth
  } = props

  const [t] = useTranslation()

  const {
    code,
    queueNumber,
    tableNumber,
    deliveryType,
    customerFullName,
    customerAccountNote
  } = printData

  const styles =
    templateType === "thermal"
      ? stylesThermal(printerWidth)
      : stylesOthers

  return (
    <Fragment>
      <PlSeparator
        forPos={forPos}
        templateType={templateType}
      />

      <div style={styles["container"]}>
        <div style={styles["header"]}>
          <div style={styles["text"]}>
            {t("شماره")}:{" "}
            <b style={styles["bold"]}>
              {queueNumber}
            </b>
          </div>

          {
            code &&
            <div style={styles["text"]}>
              {t("کد")}:{" "}
              <b style={styles["bold"]}>
                {String(code)}
              </b>
            </div>
          }
        </div>

        {
          customerFullName &&
          <div style={styles["text"]}>
            <b style={styles["bold"]}>
              {customerFullName}
            </b>
          </div>
        }

        {
          customerAccountNote &&
          <div style={styles["text"]}>
            {t("توضیحات")}:{" "}
            <b style={styles["bold"]}>
              {customerAccountNote}
            </b>
          </div>
        }

        <div style={styles["header"]}>
          <div style={styles["text"]}>
            {t("نوع")}:{" "}
            <span style={styles["bold"]}>
              {t(deliveryTypeLabels[deliveryType])}
            </span>
          </div>

          {
            !!tableNumber &&
            <div style={styles["text2"]}>
              {t("میز")}:{" "}
              <span style={styles["bold"]}>
                {tableNumber}
              </span>
            </div>
          }
        </div>

        <div style={styles["item"]} className="break-after">
          <div style={styles["foodLine"]}>
            <div style={styles["foodLine-text"]}>
              {"[    ]"}
              {" "}{thisPrinterOrderItem.foodName}{" "}
            </div>

            <div style={styles["quantity"]}>
              <MdClose />
              {thisPrinterOrderItem.quantity}
            </div>
          </div>

          {
            !thisPrinterOrderItem.isSimple &&
            <div style={styles["optionName"]}>
              {thisPrinterOrderItem.optionName}
            </div>
          }

          <div style={styles["specificationItem"]}>
            <PlSpecificationItems items={thisPrinterOrderItem.specificationItems}>
              {(specificationItem, siIndex) =>
                <div key={siIndex} style={styles["addon"]}>
                  {specificationItem.name}

                  {
                    !specificationItem.isSelectable &&
                    <Fragment>
                      <MdClose />
                      {specificationItem.quantity * thisPrinterOrderItem.quantity}
                    </Fragment>
                  }
                </div>
              }
            </PlSpecificationItems>
          </div>
        </div>
      </div>
    </Fragment>
  )
}

const stylesThermal = (printerWidth) => ({
  container: {
    fontSize: scale("19px", printerWidth),
  },

  text: {
  },

  text2: {
  },

  bold: {
    fontWeight: "bold",
  },

  item: {
    marginBottom: scale("2px"),
    fontSize: scale("30px")
  },

  optionName: {
    fontWeight: "bold",
  },

  addon: {
    display: "flex",
    alignItems: "center"
  },

  specificationItem: {
    fontWeight: "bold",
  },

  header: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: scale("2px")
  },

  foodLine: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between"
  },

  "foodLine-text": {
    maxWidth: scale("450px"),
  },

  quantity: {
    display: "flex",
    alignItems: "center",
    fontWeight: "bold",
    whiteSpace: "nowrap"
  }
})

const stylesOthers = {
  container: {
    fontSize: "15px"
  },

  bold: {
    fontWeight: "bold",
  },

  item: {
    marginBottom: "1px",
    fontSize: "18px"
  },

  optionName: {
    fontWeight: "bold"
  },

  addon: {
    display: "flex",
    alignItems: "center"
  },

  specificationItem: {
    fontWeight: "bold",
  },

  header: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "1px",
  },
  foodLine: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between"
  },

  "foodLine-text": {
    maxWidth: "250px",
  },

  quantity: {
    display: "flex",
    alignItems: "center",
    fontWeight: "bold",
    whiteSpace: "nowrap"
  }
}


export default PlOrderItemsPrintTemplate
